<template>
  <div class="waiting-list">
    <!--<a-anchor :get-container="getContainer" :show-ink-in-fixed="true" class="group-anchor">-->
    <!--  <template v-for="group in studentGroup">-->
    <!--    <a-anchor-link-->
    <!--      v-if="!clickerFiltter || group.hasBind"-->
    <!--      :key="group.key"-->
    <!--      class="group-anchor-item"-->
    <!--      :href="'#' + group.key"-->
    <!--      :title="group.key"-->
    <!--    />-->
    <!--  </template>-->
    <!--</a-anchor>-->
    <div class="waiting-title">
      <div class="waiting-title-left">
        <span>待答名单({{ studentList.length || 0 }})</span>
        <a-tooltip
          v-if="environment === 'offlineElectron' && !isNoBindDTQ"
          placement="bottom"
          :get-popup-container="triggerNode => triggerNode.parentNode"
        >
          <template slot="title">
            <span>只显示已绑定答题器学生</span>
          </template>
          <div :class="['clicker-filtter', clickerFiltter ? 'active' : '']" @click="changeFiltter" />
        </a-tooltip>
      </div>
      <div class="waiting-title-right">
        <a-popover
          v-model="popoverVisible"
          :get-popup-container="triggerNode => triggerNode.parentNode"
          placement="bottomRight"
          trigger="click"
          overlay-class-name="sort-type-popover"
        >
          <div slot="content">
            <div
              v-for="item in sortTypeList"
              :key="item.value"
              :class="['sort-type-item', { active: currentSortType === item.value }]"
              @click="onChangeSortType(item.value)"
            >
              {{ item.label }}排序
            </div>
          </div>
          <div class="sort-btn" @click="popoverVisible = !popoverVisible">
            {{ sortTypeMap[currentSortType] }}
            <a-icon type="caret-down" theme="filled" />
          </div>
        </a-popover>
      </div>
    </div>
    <div ref="waitingContent" class="waiting-content">
      <template v-if="$_.isEmpty(studentList)">
        <div class="empty-box">
          <img class="empty-img" :src="require('@/assets/test/empty.png')" alt="" width="130" height="118" />
          <div class="empty-message">当前班级暂无学生~</div>
          <div class="empty-remark">如需使用点名功能请导入学生名单</div>
        </div>
      </template>
      <template v-else>
        <!--<template v-for="group in studentGroup">-->
        <!--  <template v-if="!clickerFiltter || group.hasBind">-->
        <!--    &lt;!&ndash;<div :id="group.key" :key="group.key" class="group-item">{{ group.key }}</div>&ndash;&gt;-->
        <!--    -->
        <!--  </template>-->
        <!--</template>-->

        <template v-for="item in sortStudentList">
          <template v-if="playType === 'SINGLE'">
            <div
              v-if="!clickerFiltter || item.isBindAnswerDevice"
              :id="item.id"
              :key="item.id"
              :class="[
                'waiting-item',
                activeAnswer && activeAnswer.id === item.id ? 'active' : '',
                answerState === 'respond' ||
                (testType === 'written' && answerState === 'success' && !answerData[item.id])
                  ? 'respond'
                  : ''
              ]"
              @click="changeAnswer(item)"
            >
              <div class="waiting-item-name">
                {{ item['realName'] || item['name'] || item['loginAccount'] }}
                <template v-if="item.isBindAnswerDevice">
                  <img
                    v-if="clickerFiltter"
                    :src="require('@/assets/test/clicker_active.png')"
                    alt=""
                    width="12"
                    height="12"
                  />
                  <img v-else :src="require('@/assets/test/clicker_unactive.png')" alt="" width="12" height="12" />
                </template>
              </div>
              <!--作答中-->
              <template
                v-if="
                  answerState === 'respond' ||
                  (testType === 'written' && answerState === 'success' && !answerData[item.id])
                "
              >
                <!--选中的学生-->
                <div
                  v-if="activeAnswer && activeAnswer.id === item.id"
                  class="waiting-item-content"
                  @click="startRespond"
                >
                  <img class="wait-record-icon recording" :src="testTypeWaitEnum[testType]?.respondIcon" alt="" />
                  <div class="waiting-item-text recording">{{ testTypeWaitEnum[testType]?.respondText }}</div>
                </div>

                <!--未选中但有作答记录的学生-->
                <template v-else-if="answerData[item.id]">
                  <div
                    v-if="testType === 'written'"
                    class="written-answer"
                    @click="checkAnswer(answerData[item.id], item['realName'] || item['name'] || item['loginAccount'])"
                  >
                    <template v-if="answerData[item.id].accuracy <= 0">
                      <img class="written-answer-icon" :src="testTypeWaitEnum[testType]?.errorIcon" alt="" />
                      <span :class="['written-answer-text', testTypeWaitEnum[testType]?.errorColor]">
                        {{ testTypeWaitEnum[testType]?.errorText }}
                      </span>
                    </template>
                    <template v-else-if="answerData[item.id].accuracy < 100">
                      <img class="written-answer-icon" :src="testTypeWaitEnum[testType]?.inaccuracyIcon" alt="" />
                      <span :class="['written-answer-text', testTypeWaitEnum[testType]?.inaccuracyColor]">
                        {{ testTypeWaitEnum[testType]?.inaccuracyText }}
                      </span>
                    </template>
                    <template v-else>
                      <img class="written-answer-icon" :src="testTypeWaitEnum[testType]?.correctIcon" alt="" />
                      <span :class="['written-answer-text', testTypeWaitEnum[testType]?.correctColor]">
                        {{ testTypeWaitEnum[testType]?.correctText }}
                      </span>
                    </template>
                  </div>
                  <div
                    v-else
                    class="waiting-item-answer"
                    @click="checkAnswer(answerData[item.id], item['realName'] || item['name'] || item['loginAccount'])"
                  >
                    <div class="waiting-item-answer-left">
                      <div
                        :class="[
                          'answer-score',
                          answerData[item.id].result.scoreRate < 60
                            ? 'col-FF3C30'
                            : answerData[item.id].result.scoreRate < 85
                              ? 'col-FFA516'
                              : 'col-1DC060'
                        ]"
                      >
                        <template v-if="$store.getters.isGradeSchool">
                          <img
                            :src="Grade2ImgSrc(Number(answerData[item.id].result.overall))"
                            alt=""
                            class="score-img"
                          />
                        </template>
                        <template v-else>{{ Number(answerData[item.id].result.overall).toFixed(2) }}分</template>
                      </div>
                      <div class="answer-star">
                        <template v-for="index in 5">
                          <img
                            :key="index"
                            class="answer-star-img"
                            :src="
                              index <= fetchStarNum(answerData[item.id].result.scoreRate)
                                ? require('@/assets/common/star_highlight.png')
                                : require('@/assets/common/star_grey.png')
                            "
                            alt=""
                          />
                        </template>
                      </div>
                    </div>
                    <img class="arrow-right-icon" :src="require('@/assets/common/small_arrow_right_gray.png')" alt="" />
                  </div>
                </template>
              </template>
              <!--作答完成与等待作答-->
              <template v-else>
                <!--有作答记录的学生-->
                <template v-if="answerData[item.id]">
                  <div
                    v-if="testType === 'written'"
                    class="written-answer"
                    @click="checkAnswer(answerData[item.id], item['realName'] || item['name'] || item['loginAccount'])"
                  >
                    <template v-if="answerData[item.id].accuracy <= 0">
                      <img class="written-answer-icon" :src="testTypeWaitEnum[testType]?.errorIcon" alt="" />
                      <span :class="['written-answer-text', testTypeWaitEnum[testType]?.errorColor]">
                        {{ answerData[item.id].noReply ? '未作答' : testTypeWaitEnum[testType]?.errorText }}
                      </span>
                    </template>
                    <template v-else-if="answerData[item.id].accuracy < 100">
                      <img class="written-answer-icon" :src="testTypeWaitEnum[testType]?.inaccuracyIcon" alt="" />
                      <span :class="['written-answer-text', testTypeWaitEnum[testType]?.inaccuracyColor]">
                        {{ testTypeWaitEnum[testType]?.inaccuracyText }}
                      </span>
                    </template>
                    <template v-else>
                      <img class="written-answer-icon" :src="testTypeWaitEnum[testType]?.correctIcon" alt="" />
                      <span :class="['written-answer-text', testTypeWaitEnum[testType]?.correctColor]">
                        {{ testTypeWaitEnum[testType]?.correctText }}
                      </span>
                    </template>
                  </div>
                  <div
                    v-else
                    class="waiting-item-answer"
                    @click="checkAnswer(answerData[item.id], item['realName'] || item['name'] || item['loginAccount'])"
                  >
                    <div class="waiting-item-answer-left">
                      <div
                        :class="[
                          'answer-score',
                          answerData[item.id].result.scoreRate < 60
                            ? 'col-FF3C30'
                            : answerData[item.id].result.scoreRate < 85
                              ? 'col-FFA516'
                              : 'col-1DC060'
                        ]"
                      >
                        <template v-if="$store.getters.isGradeSchool">
                          <img
                            :src="Grade2ImgSrc(Number(answerData[item.id].result.overall))"
                            alt=""
                            class="score-img"
                          />
                        </template>
                        <template v-else>{{ Number(answerData[item.id].result.overall).toFixed(2) }}分</template>
                      </div>
                      <div class="answer-star">
                        <template v-for="index in 5">
                          <img
                            :key="index"
                            class="answer-star-img"
                            :src="
                              index <= fetchStarNum(answerData[item.id].result.scoreRate)
                                ? require('@/assets/common/star_highlight.png')
                                : require('@/assets/common/star_grey.png')
                            "
                            alt=""
                          />
                        </template>
                      </div>
                    </div>
                    <img class="arrow-right-icon" :src="require('@/assets/common/small_arrow_right_gray.png')" alt="" />
                  </div>
                </template>
                <!--选中但没有作答记录的学生-->
                <div
                  v-else-if="activeAnswer && activeAnswer.id === item.id"
                  class="waiting-item-content"
                  @click.stop="startRespond"
                >
                  <img class="wait-record-icon" :src="testTypeWaitEnum[testType]?.waitIcon" alt="" />
                  <div class="waiting-item-text">{{ testTypeWaitEnum[testType]?.waitText }}</div>
                </div>
              </template>
            </div>
          </template>
          <template v-else>
            <div
              v-if="!clickerFiltter || item.isBindAnswerDevice"
              :key="item.id"
              :class="[
                'waiting-item',
                (item.answerState === 'wait' || item.answerState === 'evaluating') && item.isBindAnswerDevice
                  ? 'waiting-answer'
                  : item.answerState === 'recording' && item.isBindAnswerDevice
                    ? 'recording-answer'
                    : ''
              ]"
              @click="changeAnswer(item)"
            >
              <div class="waiting-item-name">
                {{ item['realName'] || item['name'] || item['loginAccount'] }}
                <template v-if="item.isBindAnswerDevice">
                  <img
                    v-if="clickerFiltter"
                    :src="require('@/assets/test/clicker_active.png')"
                    alt=""
                    width="12"
                    height="12"
                  />
                  <img v-else :src="require('@/assets/test/clicker_unactive.png')" alt="" width="12" height="12" />
                </template>
              </div>
              <div v-if="item.answerState !== 'success' && item.isBindAnswerDevice" class="waiting-item-state">
                <template v-if="item.answerState === 'wait' && item.isBindAnswerDevice">
                  <img class="item-state-icon" :src="require('@/assets/common/record.png')" alt="" />
                  <div class="item-state-text">等待录音</div>
                </template>

                <template v-if="item.answerState === 'recording' && item.isBindAnswerDevice">
                  <img class="item-state-icon" :src="require('@/assets/common/record.gif')" alt="" />
                  <div class="item-state-text">录音中</div>
                </template>

                <template v-if="item.answerState === 'evaluating' && item.isBindAnswerDevice">
                  <div class="evaluating-icon-box">
                    <img class="item-state-icon" :src="require('@/assets/common/loading-white-gif.gif')" alt="" />
                  </div>
                  <div class="item-state-text">评测中</div>
                </template>
              </div>
              <div
                v-if="item.answerState === 'success' && item.isBindAnswerDevice"
                class="waiting-item-answer"
                @click="checkAnswer(answerData[item.id], item['realName'] || item['name'] || item['loginAccount'])"
              >
                <div class="waiting-item-answer-left">
                  <div
                    :class="[
                      'answer-score',
                      answerData[item.id]?.result?.scoreRate < 60
                        ? 'col-FF3C30'
                        : answerData[item.id]?.result?.scoreRate < 85
                          ? 'col-FFA516'
                          : 'col-1DC060'
                    ]"
                  >
                    <template v-if="$store.getters.isGradeSchool">
                      <img :src="Grade2ImgSrc(Number(answerData[item.id].result.overall))" alt="" class="score-img" />
                    </template>
                    <template v-else>{{ Number(answerData[item.id]?.result?.overall).toFixed(2) }}分</template>
                  </div>
                  <div class="answer-star">
                    <template v-for="index in 5">
                      <img
                        :key="index"
                        class="answer-star-img"
                        :src="
                          index <= fetchStarNum(answerData[item.id]?.result?.scoreRate)
                            ? require('@/assets/common/star_highlight.png')
                            : require('@/assets/common/star_grey.png')
                        "
                        alt=""
                      />
                    </template>
                  </div>
                </div>
                <img class="arrow-right-icon" :src="require('@/assets/common/small_arrow_right_gray.png')" alt="" />
              </div>
            </div>
          </template>
        </template>
      </template>
    </div>

    <!--  单人作答  -->
    <div
      v-if="playType === 'SINGLE'"
      :class="[
        'answer-mode',
        (answerState === 'respond' && testType !== 'written') || changePlayTypeBtnDisabled ? 'disable' : ''
      ]"
      @click="answerModeChange('SINGLE')"
    >
      <img
        v-if="answerState === 'respond' && testType !== 'written' && !changePlayTypeBtnDisabled"
        class="mode-left-icon"
        :src="require('@/assets/common/user-grey.png')"
        alt=""
      />
      <img v-else class="mode-left-icon" :src="require('@/assets/common/user-blur.png')" alt="" />
      <div class="text">单人作答</div>
      <img
        v-if="answerState === 'respond' && testType !== 'written' && !changePlayTypeBtnDisabled"
        class="mode-right-icon"
        :src="require('@/assets/common/switch_grey.png')"
        alt=""
      />
      <img v-else class="mode-right-icon" :src="require('@/assets/common/switch_blue.png')" alt="" />
    </div>

    <!--  集体作答  -->
    <div
      v-if="playType === 'TEAM'"
      :class="['answer-mode', isTeamAnswering || changePlayTypeBtnDisabled ? 'disable' : '']"
      @click="answerModeChange('TEAM')"
    >
      <img
        v-if="!isTeamAnswering && !changePlayTypeBtnDisabled"
        class="mode-left-icon"
        :src="require('@/assets/common/collectiveness-icon.png')"
        alt=""
      />
      <img v-else class="mode-left-icon" :src="require('@/assets/common/collectiveness-grey-icon.png')" alt="" />
      <div class="text">集体作答</div>
      <img
        v-if="!isTeamAnswering && !changePlayTypeBtnDisabled"
        class="mode-right-icon"
        :src="require('@/assets/common/switch_blue.png')"
        alt=""
      />
      <img v-else class="mode-right-icon" :src="require('@/assets/common/switch_grey.png')" alt="" />
    </div>

    <div class="roll-call">
      <div
        v-if="playType === 'SINGLE'"
        :class="['text', answerState === 'respond' && testType !== 'written' ? 'disable' : '']"
        @click="randomRollCall"
      >
        随机点名作答
      </div>
      <div
        v-if="playType === 'TEAM'"
        :class="[!isTeamAnswering ? 'instruct-text' : 'end-answer', teamAnswerStartBtnDisabled ? 'disabled' : '']"
      >
        <div v-if="!isTeamAnswering" class="text-btn" @click="startAnswer">下发作答指令</div>
        <div v-else class="text-btn" @click="endAnswer">结束作答</div>
      </div>
    </div>

    <div v-if="showHistory" class="answer-history" @click="checkHistoryAnswer">
      <img class="answer-history-icon" :src="require('@/assets/common/history.png')" alt="" />
      <div class="text">作答历史</div>
    </div>
  </div>
</template>

<script>
import { getDTQBindData } from '@/utils/dtq.js'
import { isRunningEnvironment, isRunningInElectron } from '@/utils/electronUtils.js'
import { Grade2ImgSrc, randomNum } from '@/utils/index.js'
import { pinyin } from 'pinyin-pro'

// 待答名单
export default {
  name: 'WaitingList',
  props: {
    // 作答类型--record：录音；operate：选择；written：笔试
    testType: {
      type: String,
      default: () => 'record'
    },
    // 显示/隐藏 作答历史
    showHistory: {
      type: Boolean,
      default: () => false
    },
    // 作答状态 -- wait： 等待；respond：作答中；success：作答完成；recording：录音中；evaluating：评测中
    answerState: {
      type: String,
      default: () => 'wait'
    },
    // 是否作答中
    respond: {
      type: Boolean,
      default: () => false
    },
    // 作答记录列表
    answerData: {
      type: Object,
      default: () => {}
    },
    // 作答模式 SINGLE 单人作答 TEAM 集体作答 ALL 全班作答
    playType: {
      type: String,
      default: () => 'SINGLE'
    },
    studentList: {
      type: Array,
      default: () => []
    },
    // 是否集体作答中
    isTeamAnswering: {
      type: Boolean,
      default: () => false
    },
    // 禁用下发作答
    teamAnswerStartBtnDisabled: {
      type: Boolean,
      default: () => false
    },
    changePlayTypeBtnDisabled: {
      type: Boolean,
      default: () => false
    },
    canTeamChangeStudent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sortable: {},
      sortStudentList: [],
      popoverVisible: false,
      currentSortType: 1,
      sortTypeMap: {
        1: '按默认',
        2: '按得分',
        3: '按作答时间'
      },
      // sortTypeList: [
      //   { label: '按默认排序', value: 1 },
      //   { label: '按得分排序', value: 2 },
      //   { label: '按作答时间排序', value: 3 }
      // ],
      testTypeWaitEnum: {
        record: {
          waitText: '等待录音',
          waitIcon:
            this.activeAnswer && this.activeAnswer.isBindAnswerDevice
              ? require('@/assets/common/record.png')
              : require('@/assets/common/disabled_record.png'),
          respondText: '点击结束录音',
          respondIcon: require('@/assets/common/record.gif')
        },
        operate: {
          waitText: '等待答题',
          waitIcon: require('@/assets/common/wait-answer-blue.png'),
          respondText: '答题中',
          respondIcon: require('@/assets/common/wait-answer-red.png')
        },
        written: {
          correctColor: 'col-1DC060',
          correctText: '答对',
          correctIcon: require('@/assets/common/solid_correct.png'),
          errorColor: 'col-FF3C30',
          errorText: '答错',
          errorIcon: require('@/assets/common/solid_error.png'),
          inaccuracyColor: 'col-FFA516',
          inaccuracyText: '不准确',
          inaccuracyIcon: require('@/assets/common/inaccuracy-yellow.png'),
          respondText: '答题中',
          respondIcon: require('@/assets/common/wait-answer-red.png')
        }
      },
      bindStudentMap: [], // 学生映射表，{学生id: 学生数据}
      studentGroup: {},
      inElectron: isRunningInElectron(),
      environment: isRunningEnvironment(),
      isNoBindDTQ: JSON.parse(sessionStorage.getItem('noBindDTQ')),
      clickerFiltter: false,
      disableTeam: true,
      canActive: true
    }
  },
  computed: {
    sortTypeList() {
      return Object.entries(this.sortTypeMap).map(item => ({ value: Number(item[0]), label: item[1] }))
    },
    classData() {
      return this.$store.getters.classData
    },
    activeAnswer() {
      return this.$store.getters.activeAnswer
    }
  },
  watch: {
    'classData.id'(val, old) {
      if (val && val !== old) {
        this.fetchStudentListByClazzId()
      }
    },
    studentList: {
      handler() {
        this.fetchStudentListByClazzId()
      }
    },
    answerData: {
      handler() {
        this.handleSort()
      },
      deep: true
    },
    disableTeam(val, old) {
      if (val && val !== old) {
        if (this.playType === 'TEAM') this.$emit('playTypeChange', 'SINGLE')
      }
    },
    canActive(val, old) {
      if (!val) {
        setTimeout(() => {
          this.canActive = true
        }, 1000)
      }
    }
  },
  destroyed() {
    this.$store.dispatch('user/setActiveAnswer', null)
    this.$bus.$off('pointerMessage', this.handlePointerMessage)
  },
  created() {
    this.$bus.$on('pointerMessage', this.handlePointerMessage)
  },
  mounted() {
    this.fetchStudentListByClazzId()
  },
  methods: {
    Grade2ImgSrc,
    onChangeSortType(value) {
      this.currentSortType = value
      this.handleSort()
      this.popoverVisible = false
    },
    handleSort() {
      const sortHandlerMap = {
        1: () => {
          this.sortStudentList = this.$_.cloneDeep(this.studentList)
        },
        2: () => {
          this.sortStudentList = this.sortStudentList.sort((a, b) => {
            let aScore = -1
            let bScore = -1
            if (typeof this.answerData[a.id]?.result?.overall === 'number') {
              aScore = Number(Number(this.answerData[a.id]?.result?.overall).toFixed(2))
            }
            if (typeof this.answerData[b.id]?.result?.overall === 'number') {
              bScore = Number(Number(this.answerData[b.id]?.result?.overall).toFixed(2))
            }
            return bScore - aScore
          })
        },
        3: () => {
          this.sortStudentList = this.sortStudentList.sort((a, b) => {
            let aTime = 0
            let bTime = 0
            if (this.answerData[a.id]?.dtLastResponse) {
              aTime = new Date(this.answerData[a.id]?.dtLastResponse).getTime()
            }
            if (this.answerData[b.id]?.dtLastResponse) {
              bTime = new Date(this.answerData[b.id]?.dtLastResponse).getTime()
            }
            return bTime - aTime
          })
        }
      }
      sortHandlerMap[this.currentSortType]()
    },
    // 查看作答历史
    checkHistoryAnswer() {
      this.$emit('checkHistoryAnswer')
    },
    // 获取班级的学生列表
    async fetchStudentListByClazzId() {
      let bindStudentList = []
      const bindStudentMap = {}
      if (this.inElectron) {
        bindStudentList = await getDTQBindData(this.classData.id)
        console.log('绑定答题器的学生', bindStudentList)
        bindStudentList
          ?.filter(el => el.isBindAnswerDevice)
          .forEach(el => {
            bindStudentMap[el.id] = el
          })
      }
      this.bindStudentMap = { ...bindStudentMap }
      this.processingStudentList()
    },
    // 处理学生名单
    processingStudentList() {
      const obj = {}
      const list = this.studentList || []
      const map = this.bindStudentMap
      list.forEach(el => {
        const hasBind = !!map[el.id]
        el.isBindAnswerDevice = !!map[el.id]
        el.answerDeviceId = map[el.id]?.answerDeviceInfo?.answerDeviceId || 0
        el.answerDeviceInfo = map[el.id]?.answerDeviceInfo || {}
        const name = el['realName'] || el['loginAccount'] || el['name']
        const initialLetter = pinyin(name?.split('')[0], {
          pattern: 'first',
          toneType: 'none',
          mode: 'surname'
        }).toUpperCase()
        const letterAsCII = initialLetter.charCodeAt()
        el.initialLetter = initialLetter
        el.initialLetterAsCII = letterAsCII
        if (obj[initialLetter]) {
          obj[initialLetter].studentList.push(el)
        } else {
          obj[initialLetter] = {
            key: initialLetter,
            id: letterAsCII,
            studentList: [el]
          }
        }
        obj[initialLetter].hasBind = obj[initialLetter].hasBind || hasBind
      })
      this.sortStudentList = this.$_.cloneDeep(list)
      this.handleSort()
      this.disableTeam = !list?.find(el => el.isBindAnswerDevice)
      this.studentGroup = Object.keys(obj)
        .map(key => obj[key])
        .sort((a, b) => {
          return a.id - b.id
        })
      this.$nextTick(() => {
        if (this.activeAnswer) {
          const index = list.findIndex(el => {
            return el.id === this.activeAnswer.id
          })
          if (index !== -1) {
            this.autoScroll(list[index])
          }
        }
      })
    },
    // 是否过滤答题器变更
    changeFiltter() {
      if (this.answerState === 'respond' && this.testType !== 'written') {
        if (!this.clickerFiltter && !this.activeAnswer.isBindAnswerDevice) {
          this.$message.warn('该学生作答中禁止隐藏')
          return
        }
      }
      this.clickerFiltter = !this.clickerFiltter
    },
    // 指定滚动的容器
    getContainer() {
      return this.$refs.waitingContent
    },
    // 获取得分星星数量
    fetchStarNum(scoreRate) {
      scoreRate = Number(scoreRate)
      if (scoreRate >= 80) {
        return 5
      } else if (scoreRate >= 60) {
        return 4
      } else if (scoreRate >= 40) {
        return 3
      } else if (scoreRate >= 20) {
        return 2
      } else {
        return 1
      }
    },
    // 自动滚动处理
    autoScroll(data) {
      const ctx = document.getElementById(data.initialLetter)
      const ctx2 = document.getElementById(data.id)
      if (!ctx || !ctx2) return
      // 可显示区域的高度
      const usableHeight = window.innerHeight - 218
      // 选中区块到分组头部的距离
      const scrollHeight = ctx2.offsetTop - ctx.offsetTop + 50
      // 分组滚动到顶部所需的距离
      let needScrollHeight = ctx.offsetTop - 50
      // 如果分组滚动到顶部后，不能完整显示选中区块
      if (scrollHeight > usableHeight) {
        needScrollHeight = ctx2.offsetTop - usableHeight / 2
      }
      this.$refs.waitingContent.scrollTop = needScrollHeight
    },
    // 变更作答学生
    changeAnswer(data) {
      if (this.playType === 'TEAM' && !this.canTeamChangeStudent) return
      if (this.answerState === 'respond' && this.testType !== 'written') return
      // 如果选中了的话，取消选中
      if (this.activeAnswer && this.activeAnswer.id === data.id) {
        this.$store.dispatch('user/setActiveAnswer', null)
      } else {
        this.$store.dispatch('user/setActiveAnswer', data)
      }
    },
    // 开始/结束录音
    startRespond() {
      if (this.activeAnswer && this.activeAnswer.isBindAnswerDevice) return
      this.$emit('startRespond')
    },
    // 查看评测结果
    checkAnswer(data, userRealName) {
      this.$emit('checkAnswer', data, userRealName)
    },
    // // 清除代答名单中的某个学生
    // remove(index) {
    //   this.waitingList.splice(index, 1)
    //   this.$store.dispatch('user/setWaitingList', this.waitingList)
    //   this.$store.dispatch('user/setActiveAnswer', this.waitingList?.length ? this.waitingList[0] : null)
    // },
    // // 清空名单
    // removeList() {
    //   const that = this
    //   this.$confirm({
    //     title: '温馨提示',
    //     content: '是否确认清空待答名单',
    //     okText: '确认',
    //     okType: 'danger',
    //     cancelText: '取消',
    //     onOk() {
    //       that.waitingList = []
    //       that.$store.dispatch('user/setActiveAnswer', null)
    //       that.$store.dispatch('user/setWaitingList', [])
    //     },
    //     onCancel() {
    //     }
    //   })
    // },
    // // 打开点名弹框
    // openRollCallDialog() {
    //   this.$emit('openRollCallDialog')
    // }
    handlePointerMessage(data) {
      switch (data.ans_str) {
        case 'D':
          if (data.key_event === 'double') {
            if (this.playType === 'SINGLE') {
              if (this.answerState === 'respond' && this.testType !== 'written') return
              this.$emit('playTypeChange', 'TEAM')
            } else {
              if (this.isTeamAnswering) return
              this.$emit('playTypeChange', 'SINGLE')
            }
          } else {
            if (this.playType === 'SINGLE') {
              this.randomRollCall()
            } else {
              if (!this.isTeamAnswering) {
                this.startAnswer()
              } else {
                this.endAnswer()
              }
            }
          }
          break
        case 'C':
          if (this.playType === 'TEAM') {
            if (this.isTeamAnswering) {
              this.endAnswer()
            } else {
              this.startAnswer()
            }
          } else if (this.playType === 'SINGLE') {
            if (data.key_event === 'double') {
              if (this.activeAnswer) this.changeAnswer(this.activeAnswer)
            }
          }
          break
        default:
          break
      }
    },

    // 作答模式修改
    answerModeChange(type) {
      if (this.changePlayTypeBtnDisabled) return
      if (type === 'SINGLE') {
        // 单人作答
        if (this.answerState === 'respond' && this.testType !== 'written') return
        if (this.disableTeam) return
        if (this.activeAnswer) this.changeAnswer(this.activeAnswer)
        this.$emit('playTypeChange', 'TEAM')
      } else {
        // 集体作答
        if (this.playType === 'TEAM' && this.isTeamAnswering) return
        this.$emit('playTypeChange', 'SINGLE')
      }
    },
    // 随机点名（单人作答）
    randomRollCall() {
      if (this.answerState === 'respond' && this.testType !== 'written') return
      // 没有名单直接返回
      if (!this.studentList || this.studentList.length <= 0) {
        return
      }
      // 获取随机索引
      let randomStudentList = JSON.parse(JSON.stringify(this.studentList))
      // 如果当前用户已被点名，则需要绕过
      if (this.activeAnswer && this.activeAnswer.id) {
        randomStudentList = randomStudentList.filter(student => student.id !== this.activeAnswer.id)
      }
      // 只显示绑定答题器学生，过滤未绑定答题器学生
      if (this.clickerFiltter) {
        randomStudentList = randomStudentList.filter(student => student.isBindAnswerDevice)
      }
      // 没有名单直接返回
      if (randomStudentList.length <= 0) {
        return
      }
      // 获取随机数
      let studentIndex = randomNum(0, randomStudentList.length)

      // 找到该学生在完整列表中的位置
      const student = randomStudentList[studentIndex]
      for (let i = 0; i < this.studentList.length; i++) {
        if (student.id === this.studentList[i].id) {
          studentIndex = i
          break
        }
      }
      this.changeAnswer(this.studentList[studentIndex])
      this.autoScroll(this.studentList[studentIndex])
    },
    // 集体作答(开始做答)
    startAnswer() {
      if (this.teamAnswerStartBtnDisabled) return
      if (!this.canActive) {
        return
      } else {
        this.canActive = false
      }
      this.$emit('teamAnswerStart')
    },
    // 集体作答（结束作答）
    endAnswer() {
      if (!this.canActive) {
        return
      } else {
        this.canActive = false
      }
      this.$emit('teamAnswerEnd')
    }
  }
}
</script>

<style lang="scss" scoped>
.waiting-list {
  height: 100%;

  .group-anchor {
    position: absolute;
    top: 50px;
    right: 0;
    width: 34px;
    height: calc(100% - 114px);
    //height: 100%;
    background-color: #ffffff;
    border-radius: 16px 0 0 16px;
    padding: 8px 0;

    .group-anchor-item {
      width: 28px;
      //height: 21px;
      font-size: 12px;
      line-height: 17px;
    }
  }

  .waiting-title {
    height: 50px;
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    line-height: 50px;
    padding: 0 14px 0 20px;
    border-bottom: 1px solid #f1f1f1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .waiting-title-left {
      display: flex;
      align-items: center;
    }

    .waiting-title-right {
      .sort-btn {
        height: auto;
        line-height: 20px;
        font-size: 16px;
        font-weight: initial;
        cursor: pointer;
      }
    }

    .waiting-icon-box {
      width: 34px;
      height: 28px;
      background: #f1f1f1;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 4px;

      .icon {
        width: 20px;
        height: 20px;
      }
    }

    .clicker-filtter {
      width: 32px;
      height: 28px;
      margin-left: 4px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f1f1f1 url('@/assets/test/clicker_unactive.png') no-repeat center center;
      background-size: 20px 20px;
      cursor: pointer;

      &.active {
        background-color: #e8f1ff;
        background-image: url('@/assets/test/clicker_active.png');
      }

      &:hover {
        background-image: url('@/assets/test/clicker_active.png');
      }
    }

    //.edit-list{
    //  display: flex;
    //  align-items: center;
    //  cursor: pointer;
    //  img{
    //    width: 12px;
    //    height: 12px;
    //  }
    //  .text{
    //    font-size: 12px;
    //    line-height: 14px;
    //    color: #1976FF;
    //    margin-left: 6px;
    //  }
    //}
  }

  .waiting-content {
    height: calc(100% - 195px);
    overflow-y: scroll;
    padding-bottom: 12px;

    .group-item {
      height: 32px;
      color: #999999;
      font-size: 14px;
      line-height: 20px;
      padding: 6px 20px;
      border-bottom: 1px solid #f1f1f1;
    }

    .waiting-item {
      height: 50px;
      line-height: 20px;
      padding: 0 20px 0 20px;
      border-bottom: 1px solid #f1f1f1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      &.waiting-answer {
        background: linear-gradient(90deg, #f9fbff 0%, #d1e4ff 100%);
        color: #1976ff !important;
      }

      &.recording-answer {
        background: linear-gradient(90deg, #fff9f9 0%, #fedbd8 100%);
        color: #ff3c30 !important;
      }

      .waiting-item-name {
        font-size: 17px;
        font-weight: 400;
        color: #333333;
      }

      .waiting-item-state {
        background: rgba(255, 255, 255, 0.8);
        border-radius: 100px 6px 6px 100px;
        display: flex;
        padding: 5px 5px 5px 8px;
        margin-right: 5px;

        .item-state-icon {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }

        .evaluating-icon-box {
          width: 16px;
          height: 16px;
          margin-right: 5px;
          font-size: 0;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(270deg, #66adff 0%, #1976ff 100%);
          .item-state-icon {
            width: 11px;
            height: 11px;
            margin-right: 0;
          }
        }

        .item-state-text {
          font-size: 12px;
          font-weight: 400;
          line-height: 17px;
        }
      }

      .waiting-item-content {
        min-width: 82px;
        height: 26px;
        border-radius: 13px 6px 6px 13px;
        margin-right: 5px;
        display: flex;
        align-items: center;
        //justify-content: space-between;
        background-color: #ffffff;
        padding: 5px 5px 5px 8px;

        .wait-record-icon {
          width: 16px;
          height: 16px;
        }

        .waiting-item-text {
          font-size: 12px;
          line-height: 16px;
          color: #1976ff;
          margin-left: 5px;

          &.recording {
            color: #ff3c30;
          }
        }
      }

      .waiting-item-answer {
        height: 36px;
        display: flex;
        align-items: center;

        .answer-score {
          text-align: center;
          height: 22px;
          font-size: 16px;
          line-height: 22px;
        }

        .answer-star {
          height: 14px;
          display: flex;

          .answer-star-img {
            width: 14px;
            height: 14px;
          }
        }

        .arrow-right-icon {
          width: 4px;
          height: 7px;
          margin-left: 6px;
        }
      }

      .written-answer {
        height: 24px;
        padding: 4px 5px;
        display: flex;
        align-items: center;

        .written-answer-icon {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }

        .written-answer-text {
          font-size: 12px;
          line-height: 24px;
        }
      }

      .sort-icon,
      .close-icon {
        width: 16px;
        height: 16px;
      }

      .close-icon {
        margin-left: 17px;
      }

      &:hover {
        background: linear-gradient(90deg, #fafafa 0%, #f1f1f1 100%);

        .name {
          font-weight: 600;
        }
      }

      &.active {
        background: linear-gradient(90deg, #f9fbff 0%, #d1e4ff 100%);

        &.respond {
          background: linear-gradient(90deg, #fff9f9 0%, #fedbd8 100%);
        }

        .name {
          color: #1976ff;
          font-weight: 600;
        }
      }
    }

    .empty-box {
      height: 100%;
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;

      .empty-message {
        font-size: 20px;
        line-height: 28px;
        color: #333333;
        margin-top: 20px;
      }

      .empty-remark {
        font-size: 13px;
        line-height: 18px;
        color: #999999;
        margin-top: 10px;
      }
    }
  }

  .answer-mode {
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 51px 0 51px;
    background: linear-gradient(270deg, #f6f6f6 0%, #e8f1ff 100%);
    border-radius: 18px 18px 0 0;
    cursor: default;

    &.disable {
      background: #f6f6f6;

      .text {
        color: #c8c8c8;
      }
    }

    .mode-left-icon {
      width: 14px;
      height: 14px;
    }

    .text {
      font-size: 14px;
      font-weight: 400;
      color: #1976ff;
      line-height: 20px;
      margin: 0 4px;
    }

    .mode-right-icon {
      width: 10px;
      height: 10px;
    }
  }

  .roll-call {
    height: 36px;
    padding: 0 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: default;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    line-height: 36px;

    .text {
      text-align: center;
      color: #ffffff;
      width: 288px;
      background: linear-gradient(-90deg, #66adff 0%, #1976ff 100%);
      border-radius: 29px;

      &.disable {
        background: linear-gradient(-90deg, #c8c8c8 0%, #c8c8c8 100%);
      }
    }

    .instruct-text {
      width: 100%;
      background: linear-gradient(270deg, #66adff 0%, #1976ff 100%);
      border-radius: 18px;
    }

    .end-answer {
      width: 100%;
      background: #ff3c30;
      border-radius: 18px;
    }

    .disabled {
      background: #c8c8c8;
    }

    .text-btn {
      width: 100%;
      height: 100%;
      line-height: 36px;
      text-align: center;
    }
  }

  .answer-history {
    margin: 8px auto 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 0;
    cursor: default;

    .answer-history-icon {
      width: 14px;
      height: 14px;
      margin-right: 6px;
    }

    .text {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
    }
  }
}

::v-deep .ant-anchor-wrapper {
  //background-color: #1DC060;
  width: 34px;
  height: 100%;
  margin-left: 0;
  padding-left: 0;

  .ant-anchor {
    .ant-anchor-ink {
      display: none;
    }

    .ant-anchor-link {
      &.group-anchor-item {
        display: block;
        width: 28px;
        height: 21px;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        padding: 0;

        &:hover {
          background-color: #e8f1ff;
          color: #1976ff;

          .ant-anchor-link-title {
            color: #1976ff;
          }
        }

        &.ant-anchor-link-active {
          & > .ant-anchor-link-title {
            color: #1976ff;
          }
        }

        .ant-anchor-link-title {
          color: #333333;
        }
      }
    }
  }
}

::v-deep .sort-type-popover {
  .ant-popover-inner-content {
    padding: 5px 0;
    .sort-type-item {
      padding: 5px 8px;
      cursor: pointer;
      &.active {
        background: #1976ff;
        color: #ffffff;
      }
    }
  }
}

.col-1DC060 {
  color: #1dc060 !important;
}

.col-FFA516 {
  color: #ffa516 !important;
}

.col-FF3C30 {
  color: #ff3c30 !important;
}

.score-img {
  width: 22px;
  height: 22px;
}
</style>
